import Component from 'vue-class-component';
import { AppVue } from '../../../app.vue';
import { AppConfig } from '../../../app.config';

import './header.scss';

@Component({
    template: require('./header.html'),
    name: 'Hader',

    props: {
        platformHeader: {
            type: Array,
        },
    },
})
export class Header extends AppVue {
    created() {

    }
    name = '';
    data='';
    async mounted() {
        this.data= sessionStorage.getItem('user');
        this.name=JSON.parse(this.data).nickname;
    }
}